import React, { createContext, useEffect, useState } from "react";

import { useDispatch, useSelector } from "react-redux";
import { getSimpleWishListThunk, getWishListThunk } from "redux/Reducers/WishList/WishListSlice";

export const WishListContext = createContext();

const WishListProvider = ({ children }) => {
  const [wishList, setWishList] = useState();
  const [simpleWishList, setSimpleWishList] = useState(new Map());

  const dispatch = useDispatch();

  const {
    wishListData,
    simpleWishListData,
    isFetchingWishList,
  } = useSelector(state => state.WishList);

  const updateWishList = () => {
    dispatch(getWishListThunk());
  }

  const updateSimpleWishList = async () => {
    try {
      return await dispatch(getSimpleWishListThunk()).unwrap();
    } catch (err) {
      throw err;
    }
  }

  useEffect(() => {
    updateSimpleWishList();
  }, []);

  useEffect(() => {
    if (!wishListData) return;

    setWishList(wishListData);
  }, [wishListData]);

  useEffect(() => {
    if (!simpleWishListData) return;

    const simpleWishListAuxMap = new Map();

    simpleWishListData.forEach(product => simpleWishListAuxMap.set(product.skuId, true));

    setSimpleWishList(simpleWishListAuxMap);
  }, [simpleWishListData]);

  return (
    <WishListContext.Provider value={{ isFetchingWishList, wishList, simpleWishList, updateWishList, updateSimpleWishList }}>
      { children }
    </WishListContext.Provider>
  );
}

export default WishListProvider;
